<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn 
        v-bind="attrs"
        v-on="on" 
        x-medium
        large block 
        rounded 
        color="primary"
        dark>
          Agregar Novedad
      </v-btn>
    </template>
    <v-card>
      <v-toolbar
        dark
        color="secondary">
          <v-btn
            icon
            dark
            class="btn btn-primary"
            @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
          <v-toolbar-title>Agregar Novedad</v-toolbar-title>

          <template v-slot:extension>
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="accent"></v-tabs-slider>

              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
          </template> 

      </v-toolbar>
      <v-tabs-items v-model="tab" class="container mt-5">  
        <v-tab-item>
          <div class="container mt-4">
            <addNovelties/>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>
  
<script>

  import addNovelties from '@/views/novelties/pages/add_novelties/components/form_add_novelties_component.vue';
  import  EventBus  from '@/utils/event_bus.js';

  export default {
    
    name:"addNoveltiesPage",
    components: {
      addNovelties,
    },
    data () {
      return {
        dialog: false,
        tab: null,
        items: [
          "Datos Completos"
        ],
      }
    },

    async mounted() {
      EventBus.$on('formNovelties-submitted-successfully', () => {
        this.closeDialog()  
        EventBus.$emit('reload-novelties');
      });
    },

    methods: {
      closeDialog() {
        this.$store.commit('RESET_STATE');
        this.dialog = false;
        window.location.reload();
      },
    }
  };
</script>
  